import React, { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { useAuthStore } from "../stores/authStore";
import { useRouter } from "./Router";
import {
  startReminderScheduler,
  stopReminderScheduler,
} from "../lib/reminderScheduler";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { checked, setupComplete, authenticated } = useAuthStore(
    useShallow((s) => ({
      checked: s.checked,
      setupComplete: s.setupComplete,
      authenticated: s.authenticated,
    })),
  );
  const checkAuth = useAuthStore((s) => s.checkAuth);
  const { path, navigate } = useRouter();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (!checked) return;

    if (!setupComplete && path !== "/setup") {
      navigate("/setup");
    } else if (setupComplete && !authenticated && path !== "/login") {
      navigate("/login");
    } else if (authenticated && (path === "/login" || path === "/setup")) {
      navigate("/");
    }
  }, [checked, setupComplete, authenticated, path, navigate]);

  // Start the in-page reminder scheduler once the user is authenticated.
  // Stops when they log out so we don't keep polling /api/events/reminders.
  useEffect(() => {
    if (!authenticated) return;
    void startReminderScheduler();
    return () => stopReminderScheduler();
  }, [authenticated]);

  if (!checked) {
    return <div className="splash" />;
  }

  return <>{children}</>;
}
